import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { reactStates, useFile } from "../context/filecontext";
import AnalysisTools from "./analysistools";
import PotreeViewer from "./potree";
import * as THREE from "three";
import { convexMesh } from "../utils/three/convex/cnvexUtils";
import {
  Loader,
  ChevronLeft,
  ChevronRight,
  LayoutPanelLeft,
  PanelRightClose,
} from "lucide-react";
import Footer from "../components/footer";
import { getExtraPointHighlight } from "./overUnderBreak/highlightPoints";
import { GetOreDillution } from "./overUnderBreak/getOreDillution";
import { addSceneMethods } from "../utils/three/potree/potreeUtils";
import Header from "../components/header-viewer";
export let manager = {};

const FileViewerPage = () => {
  const location = useLocation();
  const {
    metadataUrl,
    clearMetadataUrl,
    uploadResponseData,
    updateUploadResponseData,
    showNotificationWithConfig,
    designLasUrl,
    setDesignLasUrl,
  } = useFile();
  let gStates = useFile();
  console.log(gStates, "gStates");
  const navigate = useNavigate();
  const viewerContainerRef = useRef(null);
  const [viewer, setViewer] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(true);
  const [showPotreeSidebar, setShowPotreeSidebar] = useState(true);
  const [selectedBlasts, setSelectedBlasts] = useState([]);
  const [oreFile, setOreFile] = useState(null);
  const [measurements, setMeasurements] = useState({
    volume: { totalVolume: 0, surfaceArea: 0 },
    overbreak: { volume: 0, percentage: 0, maxLength: 0 },
    underbreak: { volume: 0, percentage: 0, maxLength: 0 },
    density: { pointDensity: 0, coverage: 0 },
    plannedDesignVolume: {
      volume: 0,
    },
    volume: {
      totalVolume: 0,
      surfaceArea: 0,
    },
    oreDillution: 0,
  });

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
  // const API_BASE_URL = 'https://aiq2h6wnn7.us-east-1.awsapprunner.com';

  // Fetch volume data if not available
  useEffect(() => {
    console.log("uploadResponseData changed:", uploadResponseData);
    if (uploadResponseData?.file_id && !uploadResponseData?.volume) {
      fetchVolumeData();
    }
  }, [uploadResponseData]);

  // Initialize the viewer
  useEffect(() => {
    if (metadataUrl && viewerContainerRef.current) {
      initPotreeViewer();
    }
  }, [metadataUrl, oreFile]);

  const fetchVolumeData = async (lasUrl) => {
    if (!uploadResponseData?.file_id) return;
    // if (!lasUrl) lasUrl = "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/c3VzaGls/flat-design/preprocessfiles/556_N_BH4_B4.las";
    setIsCalculating(true);
    try {
      const response = await fetch(`${API_BASE_URL}/calculate-volume/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          las_path_aws:
            "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/merge-wall.las",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch volume data");
      }

      const volumeData = await response.json();
      console.log(volumeData, "volume data");
      // Update context with volume data
      // updateUploadResponseData({
      //   ...uploadResponseData,
      //   volume: volumeData.volume,
      // });
      window.designVolume = volumeData.volume;
      // Update local measurements state
      setMeasurements((prev) => ({
        ...prev,
        volume: {
          totalVolume: volumeData.volume,
          surfaceArea: 0,
        },
      }));

      // showNotificationWithConfig({
      //   type: "success",
      //   message: "Volume calculation complete",
      //   duration: 3000,
      // });

      return volumeData;
    } catch (error) {
      console.error("Error fetching volume data:", error);
      showNotificationWithConfig({
        type: "error",
        message: "Failed to calculate volume",
        duration: 5000,
      });
    } finally {
      setIsCalculating(false);
    }
  };

  const initPotreeViewer = () => {
    if (!viewerContainerRef.current) {
      console.error("Viewer container not found!");
      return;
    }
    try {
      if (!manager.pViewer) {
        const potreeViewer = new window.Potree.Viewer(
          viewerContainerRef.current
        );
        window.potreeViewer = potreeViewer;
        manager.pViewer = potreeViewer;
        // Basic settings
        potreeViewer.setEDLEnabled(true);
        potreeViewer.setFOV(60);
        potreeViewer.setPointBudget(1_000_000);

        // Set initial background color
        potreeViewer.setBackground("black");

        // Create renderer settings for background
        if (potreeViewer.renderer) {
          potreeViewer.renderer.setClearColor(0x000000); // Black
          potreeViewer.renderer.clear();
        }
      }
      // return
      // Load point cloud
      if (manager?.pViewer?.actual)
        manager.pViewer.actual.visible = false
      reactStates.actualMetadataUrl = metadataUrl 
      // if (manager?.pViewer?.actual) manager.pViewer.actual.visible = false;
      window.Potree.loadPointCloud(metadataUrl, "PointCloud", (e) => {
        let pCloud = e.pointcloud;
        manager.pViewer.scene.addPointCloud(e.pointcloud);
        manager.pViewer.actual = e.pointcloud;
        addSceneMethods(manager.pViewer);
        pCloud.visible = true;
        let p1Obj = new THREE.Object3D();
        manager.pViewer.scene.scene.add(p1Obj);
        manager.pViewer.fitToScreen();
        // let backendUrl = process.env.REACT_APP_BACKEND_URL
        // let glbUrl = `${backendUrl}/get-glb/?las_path_aws=`

        // let getOreDillution = new GetOreDillution({
        //   designLasUrl : "http://localhost:3000/glb/design_mesh.glb",
        //   actualLasUrl : "http://localhost:3000/glb/actual_mesh.glb",
        //   states : gStates,
        // })
        // let getOreDillution = new GetOreDillution({
        //   designLasUrl : glbUrl + "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/c3VzaGls/flat-design/preprocessfiles/556_N_BH4_B4.las",
        //   actualLasUrl : glbUrl + "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/merge-wall.las",
        //   states : gStates,
        // })

        // getOreDillution.init();

        // console.log(getOreDillution,"datat")

        // addRefSphere(potreeViewer.scene.scene, pCloud.position, 5, 'green')
        // getExtraPointHighlight(p1Obj);
      });

      if (oreFile) {
        for (let i = 0; i < oreFile.length; i++) {
          if (!oreFile[i]) continue;
          reactStates.designMetadataUrl = oreFile[i]
          window.Potree.loadPointCloud(oreFile[i], "OrePointCloud", (e) => {
          manager.pViewer.scene.addPointCloud(e.pointcloud);
          manager.pViewer.design = e.pointcloud

            manager.pViewer.fitToScreen();
            manager.pViewer.design = e.pointcloud;
            // getOreDillution()

            // let designMetadataUrl =
          });
        }
      }

      setViewer(manager.pViewer);
    } catch (error) {
      console.error("Error initializing Potree viewer:", error);
    }
  };

  const handleUploadNew = () => {
    if (
      window.confirm(
        "Are you sure you want to upload a new file? Current viewer data will be cleared."
      )
    ) {
      clearMetadataUrl();
      navigate("/upload");
    }
  };

  if (!metadataUrl) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <div className="mb-4">
            <Loader className="w-8 h-8 text-blue-500 animate-spin mx-auto" />
          </div>
          <p className="text-slate-600">
            No file loaded. Redirecting to upload page...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-slate-50">
      <header>
        <Header />
      </header>
      <div className="flex flex-1 min-h-0 relative">
        {/* Analysis Panel Toggle Button */}
        <button
          onClick={() => setShowAnalysis(!showAnalysis)}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-50 bg-white p-2 rounded-r-md shadow-md border border-l-0 border-gray-200 hover:bg-gray-50"
          title={showAnalysis ? "Hide Analysis Panel" : "Show Analysis Panel"}
        >
          {showAnalysis ? (
            <ChevronLeft size={20} />
          ) : (
            <ChevronRight size={20} />
          )}
        </button>

        {/* Analysis Sidebar */}
        <div
          className={`
          ${showAnalysis ? "w-96" : "w-0"} 
          flex flex-col bg-white shadow-lg border-r border-slate-200 
          transition-all duration-300 ease-in-out overflow-hidden
        `}
        >
          <div className="flex-1 overflow-auto">
            <AnalysisTools
              isCalculating={isCalculating}
              measurements={setMeasurements}
              uploadResponse={uploadResponseData}
              onCalculate={fetchVolumeData}
              selectedBlasts={selectedBlasts}
            />
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col min-w-0 relative">
          <PotreeViewer
            viewerContainerRef={viewerContainerRef}
            handleUploadNew={handleUploadNew}
            selectedBlasts={selectedBlasts}
            onBlastSelection={setSelectedBlasts}
            measurements={measurements}
            metadata={metadata}
            viewer={viewer}
            metadataUrl={metadataUrl}
            showPotreeSidebar={showPotreeSidebar}
            setShowPotreeSidebar={setShowPotreeSidebar}
            setOreFile={setOreFile}
          />

          {/* Potree Sidebar Toggle Button */}
          <button
            onClick={() => setShowPotreeSidebar(!showPotreeSidebar)}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-50 bg-white p-2 rounded-l-md shadow-md border border-r-0 border-gray-200 hover:bg-gray-50"
            title={
              showPotreeSidebar ? "Hide Potree Sidebar" : "Show Potree Sidebar"
            }
          >
            {showPotreeSidebar ? (
              <PanelRightClose size={20} />
            ) : (
              <LayoutPanelLeft size={20} />
            )}
          </button>
        </div>
      </div>

      <div className="flex-shrink-0">
        <Footer />
      </div>
    </div>
  );
};

export default FileViewerPage;
